import { render, staticRenderFns } from "./SMSActivationView.vue?vue&type=template&id=d36ca606&scoped=true"
import script from "./SMSActivationView.vue?vue&type=script&lang=js"
export * from "./SMSActivationView.vue?vue&type=script&lang=js"
import style0 from "./SMSActivationView.vue?vue&type=style&index=0&id=d36ca606&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d36ca606",
  null
  
)

export default component.exports